import o from "./SmIcon.vue2.js";
import './SmIcon.css';/* empty css            */
import _ from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ _(o, [["__scopeId", "data-v-fea68da0"]]);
export {
  m as default
};
